// extracted by mini-css-extract-plugin
export default {"container":"AutoGlassForm_container__gK-Iw","autoGlassText":"AutoGlassForm_autoGlassText__eoOIh","formRow":"AutoGlassForm_formRow__GkIzE"};